import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "top-navigation" }
const _hoisted_2 = {
  key: 0,
  class: "float-left margin-right-20"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_btn = _resolveComponent("q-btn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menu, (item) => {
      return (_openBlock(), _createElementBlock(_Fragment, {
        key: item.id
      }, [
        (
        !item.disabled &&
        Array.isArray(item.ownerRole) &&
        item.ownerRole.includes(_ctx.store.state.ownerRole) &&
        Array.isArray(_ctx.store.state.userVaultnPermissions) &&
        Array.isArray(item.rbacRole) &&
        item.rbacRole.some(r => _ctx.store.state.userVaultnPermissions.includes(r)) &&
        (!item.featureFlag || _ctx.featureFlagChecks[item.featureFlag]?.value)
      )
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(_component_q_btn, {
                color: "primary",
                label: item.text,
                to: item.href,
                class: _normalizeClass({ highlighted: item.id === _ctx.highlightedIndex }),
                style: _normalizeStyle(item.id === _ctx.highlightedIndex ? 'color: #2aa1e8; font-weight: 600;' : '')
              }, null, 8, ["label", "to", "class", "style"])
            ]))
          : _createCommentVNode("", true)
      ], 64))
    }), 128))
  ]))
}